import { site } from "../../../data/site";
import styles from "./Footer.module.css";

const footerLinks = {
  Explore: [
    ["Home", "/"],
    ["Services", "/services"],
    ["Our Clients", "/our-clients"],
    ["Products", "/products"],
    ["Pricing", "/pricing"],
  ],
  Company: [
    ["About us", "/about"],
    ["Contact", "/contact"],
    ["FAQs", "/pricing#faq"],
    ["Privacy policy", "/privacy-policy"],
    ["Terms & conditions", "/terms"],
  ],
};

function Arrow() {
  return <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 15 15 5M5 5h10v10" /></svg>;
}

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.intro}`}>
        <div>
          <span className={styles.eyebrow}>A little ambition. A whole new chapter.</span>
          <h2>Your business.<br /><span>More possibilities.</span></h2>
        </div>
        <a href="/contact" className={styles.startLink}><span>Let's make<br /> it happen</span><Arrow /></a>
      </div>
      <div className={`container ${styles.grid}`}>
        <div className={styles.brandCol}>
          <p className={styles.about}>{site.about}</p>
          <p className={styles.location}><span aria-hidden="true" />{site.contact.location}</p>
        </div>
        {Object.entries(footerLinks).map(([title, links]) => (
          <nav className={styles.col} aria-label={`${title} links`} key={title}>
            <h2>{title}</h2>
            <ul>{links.map(([label, href]) => <li key={href}><a href={href}>{label}</a></li>)}</ul>
          </nav>
        ))}
        <div className={`${styles.col} ${styles.contactCol}`}>
          <h2>Get in touch</h2>
          <div className={styles.social}>
            <a href={site.social.facebook} className={styles.socialLink} target="_blank" rel="noopener noreferrer" aria-label={`${site.name} on Facebook`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 21v-8h3l.5-4H14V7c0-1 .5-1.5 1.5-1.5H18V2.2c-.8-.1-1.8-.2-2.8-.2C12.3 2 10 3.8 10 7v2H7v4h3v8" /></svg>
              <span>Facebook</span>
            </a>
            <a href={site.social.instagram} className={styles.socialLink} target="_blank" rel="noopener noreferrer" aria-label={`${site.name} on Instagram`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r=".7" fill="currentColor" stroke="none" /></svg>
              <span>Instagram</span>
            </a>
          </div>
          <a href={site.contact.whatsappHref} target="_blank" rel="noopener noreferrer" className={styles.whatsapp}>Chat on WhatsApp<Arrow /></a>
        </div>
      </div>
      <div className={`container ${styles.bottom}`}>
        <p>© {new Date().getFullYear()} {site.name}. All rights reserved.</p>
        <a href="#main-content" className={styles.backToTop}>Back to top<Arrow /></a>
      </div>
    </footer>
  );
}
